<template>
	<agency-properties-layout>
		<div class="agency-properties-search-box">
			<h1>Segnala un nuovo immobile</h1>

			<div class="form-inline">
                <vue-google-autocomplete
                    class="flex-fill form-control"
                    :class="{'is-invalid': form.errors.name}"
                    @place_changed="getAddressData"
                    placeholder="Via Europa 30, Bologna"
                ></vue-google-autocomplete>
				<button type="button" class="btn btn-primary" @click="startWizard()" :disabled="this.address === ''">Segnala immobile</button>
			</div>
		</div>

		<div class="agency-properties-table-card mb-5">
			<h3>Gli immobili che hai caricato</h3>

			<div class="table-responsive">
				<table class="table">
					<tbody>
						<tr v-for="property in this.properties">
							<td><img src="/images/property_icon.svg" class="d-inline pr-3" alt="property_icon" /></td>
							<td><strong class="pr-3">{{ formatAddress(property) }}</strong></td>
							<td><span class="text-muted pr-3 text-nowrap">{{ getFloorLabel(property) }}</span></td>
							<td><span class="text-muted pr-3 text-nowrap">{{ property.rooms }} locali</span></td>
							<td><span class="text-muted text-nowrap">{{ property.surface }} mq</span></td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</agency-properties-layout>
</template>

<script>
import AgencyPropertiesLayout from '@/Pages/Agency/Properties/Layouts/AgencyPropertiesLayout'
import * as VueGoogleMaps from 'vue2-google-maps'
import {findOptionLabel, apt_floor_options} from "@/helpers/select-options";

export default {
    props: ['properties'],

	components: {
		AgencyPropertiesLayout,
        'vue-google-autocomplete': VueGoogleMaps.Autocomplete,
	},

    data() {
	    return {
	        address: '',
            form: this.$inertia.form({
                name: null,
                active: false,
            }),
			apt_floor_options
        }
    },

    methods: {
		findOptionLabel,

		getFloorLabel(property)
		{
			if (property.floor_number == null) return "";
			if(!isNaN(property.floor_number)){
				return `${property.floor_number}° piano`
			}

			return this.findOptionLabel(this.apt_floor_options, property.floor_number);
		},

        formatAddress(property) {
            return property.address + ' ' + property.house_number + ', ' + property.municipality
        },

        getAddressData(payload) {
            let address = this.getAddressComponent(payload, 'route')

            this.address = payload.formatted_address
            this.form.name = address.long_name
        },

        getAddressComponent(payload, type) {
            let {address_components} = payload

            return address_components.filter(i => i.types.includes(type))[0]
        },

	    startWizard() {
	        this.$inertia.visit('/wizard/1?address=' + this.address)
        }
    },

    beforeMount() {
        localStorage.removeItem('current_property_id')
        localStorage.removeItem('current_property')
    }
}
</script>
